import * as reviews from '@/services/reviews.js'

export default {
  async getAllReviews({ state, commit }) {
    const data = await reviews.getAllReviews()
    return data
  },
  async getAllReviewsByUnit({ state, commit }, id) {
    const data = await reviews.getAllReviewsByUnit(id)
    return data
  },
  async getAllReviewsByUnitDepartment({ state, commit }, params) {
    const data = await reviews.getAllReviewsByUnitDepartment(params)
    return data
  },
  async getUnitsReviews({ state, commit }) {
    const data = await reviews.getUnitsReviews()
    return data
  },
}
